module.exports = __webpack_public_path__ + "img/leavy-banner-icon-blue.89053147.svg";